import { Component, Input } from '@angular/core';
import { PreferencesService } from '../../service/preferences.service';
import { ViewMode } from '../../enum/view.mode';
import { SelectOption } from '../../model/select.option';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-view-preferences-picker',
  templateUrl: './view-preferences-picker.component.html',
  styleUrls: ['./view-preferences-picker.component.scss']
})
export class ViewPreferencesPickerComponent {
  viewModes: Array<SelectOption>;

  colorAsStatus: boolean;

  @Input() silent = false;
  // Qual preferência esse picker controla. Default = `statusColorAsBackgroundColor`
  // (Minhas submissões, chair, etc.). Minhas Revisões passa
  // `statusColorAsBackgroundColorReviews` pra ter toggle independente.
  @Input() preferenceKey: 'statusColorAsBackgroundColor' | 'statusColorAsBackgroundColorReviews' | 'statusColorAsBackgroundColorSessions' = 'statusColorAsBackgroundColor';

  constructor(public preferencesService: PreferencesService, public notificationService: NotificationService) {
    this.viewModes = ViewMode.toSelectable();
  }

  ngOnInit(): void {
    // Ler AQUI (não no constructor) porque `preferenceKey` só é
    // atribuído após o Input binding, o que acontece depois do ctor.
    this.colorAsStatus = <boolean>(this.preferencesService.getPreference(this.preferenceKey));
  }

  submitPreferences(): void {
    this.preferencesService.saveCachedPreferences().subscribe(user => {
      if (!this.silent) {
        this.notificationService.notify('profile.updated-user-preferences');
      }
    });
  }

  updateBackgroundAndSave(): void {
    this.preferencesService.changePreference(this.preferenceKey, this.colorAsStatus);
    this.submitPreferences();
  }
}
